import AttachmentPicker from '@/components/attachments/AttachmentPicker';
import { TextArea } from '@/components/ui';

export default function SubmissionEditor({
  value = { text: '', attachments: [] },
  onChange,
  schoolId,
  domain,
  currentUser,
  textLabel = 'Response',
  textInstruction,
  textPlaceholder,
  textRequired = false,
  textError,
  maxLength = 1000,
  allowAttachments = true,
  attachmentLabel = 'Add photos or documents',
  accept,
  maxFiles = 5,
  disabled = false,
  deleteOnRemove = true,
  onAttachmentUploaded,
  onUploadBusyChange,
}) {
  const update = patch => onChange?.({ ...value, ...patch });

  return (
    <div className="space-y-4">
      <TextArea
        label={textLabel}
        instruction={textInstruction}
        placeholder={textPlaceholder}
        required={textRequired}
        disabled={disabled}
        error={textError}
        maxLength={maxLength}
        value={value.text || ''}
        onChange={event => update({ text: event.target.value })}
      />
      {allowAttachments && (
        <AttachmentPicker
          schoolId={schoolId}
          domain={domain}
          currentUser={currentUser}
          value={value.attachments || []}
          onChange={attachments => update({ attachments })}
          maxFiles={maxFiles}
          accept={accept}
          label={attachmentLabel}
          disabled={disabled}
          deleteOnRemove={deleteOnRemove}
          onUploaded={onAttachmentUploaded}
          onUploadingChange={onUploadBusyChange}
        />
      )}
    </div>
  );
}
